var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ideogram-show"},_vm._l((_vm.printData),function(data,index){return _c('span',{key:index,class:[data.ideogramClass, _vm.highlights && _vm.highlights[index] ? 'highlight' : ''],style:({ color: data.toneColor })},[_vm._v(_vm._s(data.character))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }